import { ShieldStarterPromoCode } from "@pages/ShieldStarter/Components/Modals"
import React from "react"

interface IModalViewConfig {
    [key: string]: {
        viewComponent: Function
    }
}

export enum MODALVIEW {
    SHIELD_STARTER_PROMOCODE = "SHIELD_STARTER_PROMOCODE"
}

export const ModalViewConfig: IModalViewConfig = {

    [MODALVIEW.SHIELD_STARTER_PROMOCODE]:{
        viewComponent: ShieldStarterPromoCode
    }



}